import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isSnackBarVisible: false,
  message: null,
  type: null,
};

const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    showSnackbar: {
      reducer(state, action) {
        state.isSnackBarVisible = true;
        state.message = action.payload.message;
        state.type = action.payload.type || "success";
      },
      prepare(message, type) {
        return {
          payload: { message, type },
        };
      },
    },
    hideSnackbar(state) {
      state.isSnackBarVisible = false;
      state.message = null;
      state.type = null;
    },
  },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;

export default snackbarSlice.reducer;
